export enum InvitationType {
  VERIFICATION = 'verification',
  USER = 'user'
}
